import axios from 'axios';
import sesionService from '@/services/SesionService';

export default {
	async getAllCategories() {
		const HEADER = await sesionService.getHeader();
		if (HEADER !== '') return axios.get('/category/all', HEADER).then((res) => res.data);
	},

	async getAllForSelect(query) {
		const HEADER = await sesionService.getHeader();
		if (HEADER !== '')
			return axios
				.get(`/category/for-select?query=${query}`, HEADER)
				.then((res) => res.data);
	},

	async getAllCategoriesAsync() {
		const HEADER = await sesionService.getHeader();
		if (HEADER !== '') {
			try {
				let res = await axios.get('/category/all', HEADER);
				return res;
			} catch (error) {
				console.log(error);
			}
		}
	},

	async getCategory(id) {
		const HEADER = await sesionService.getHeader();
		if (HEADER !== '') return axios.get('/category/' + id, HEADER).then((res) => res.data);
	},

	async postCategory(title, subCategories) {
		const HEADER = await sesionService.getHeader();
		if (HEADER !== '')
			return axios
				.post('/category', { title, subCategories }, HEADER)
				.then((res) => res.data);
	},

	async putCategory(id, title, subCategories) {
		const HEADER = await sesionService.getHeader();
		if (HEADER !== '')
			return axios
				.put('/category/' + id, { title, subCategories }, HEADER)
				.then((res) => res.data);
	},

	async deleteCategory(id) {
		const HEADER = await sesionService.getHeader();
		if (HEADER !== '')
			return axios.delete('/category/' + id, HEADER).then((res) => res.data);
	}
};
